import { MantineThemeOverride } from "@mantine/core";
import { themeOther } from "@rpi/openapi-core";
import { amplifyGlobalStyles } from "./amplifyGlobalStyles";

const colors: MantineThemeOverride["colors"] = {
  brand: ["#320161", "#b1aec4", "#504a73", "#6A49B6", "#F1F4F8", "#E0E9F0", "#5A349E", "#320161", "#320161"],
  dark: ["#292929", "#464646", "#989898", "#292929", "#464646", "#989898", "#292929", "#464646", "#989898"],
  text: ["#b3b3b3", "#464646", "#292929", "#999999", "#5c5c5c", "#050203", "#464646", "#050203", "#050203", "#656565"],
  sky: ["#ffffff", "#EDEDFD", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#f2f2f2", "#e6e6e6", "#d9d9d9", "#d9d9d9"],
  spark: ["#fadeda", "#fadeda", "#fadeda", "#f5beb5", "#f5beb5", "#f56b55", "#b93a2e", "#b93a2e", "#b93a2e", "#b93a2e"],
  mellow: [
    "#e7d54f",
    "#e7d54f",
    "#e7d54f",
    "#e7d54f",
    "#e7d54f",
    "#e7d54f",
    "#ddd179",
    "#ddd179",
    "#ddd179",
    "#ddd179",
  ],
  calm: ["#f4f7fa", "#f4f7fa", "#f4f7fa", "#f4f7fa", "#f4f7fa", "#bcccdd", "#6da2ec", "#6da2ec", "#6da2ec", "#6da2ec"],
  amethyst: [
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
    "#a57fa0",
  ],
  green: ["#9cf0d3", "#9cf0d3", "#9cf0d3", "#9cf0d3", "#9cf0d3", "#52c8b1", "#52c8b1", "#52c8b1", "#52c8b1", "#52c8b1"],
  darkMode: [
    "#2f2e2e",
    "#2f2e2e",
    "#2f2e2e",
    "#2f2e2e",
    "#272626",
    "#242323",
    "#242323",
    "#242323",
    "#242323",
    "#242323",
  ],
};

export const rpaTheme: MantineThemeOverride = {
  colorScheme: "light",
  fontFamily: "sofia-pro, sans-serif",
  lineHeight: "24px",
  radius: {
    sm: 4,
    md: 8,
    lg: 16,
    xl: 24,
  },
  defaultRadius: "sm",
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
  },
  breakpoints: {
    md: 320,
    lg: 768,
  },
  fontSizes: {
    sm: 14,
    md: 16,
    lg: 24,
    xl: 34,
  },
  headings: {
    fontFamily: "neue-haas-grotesk-display, sans-serif",
    fontWeight: 400,
    sizes: {
      h3: { lineHeight: "120%" },
      h4: { lineHeight: "120%" },
      h5: { lineHeight: "120%" },
      h6: { lineHeight: "140%" },
    },
  },
  primaryColor: "brand",
  white: "#ffffff",
  colors,
  other: themeOther,
  globalStyles: amplifyGlobalStyles,
};
